module.exports = __webpack_public_path__ + "static/media/logo.46b6b491.svg";